import { render, staticRenderFns } from "./HowItWorksMobileView.vue?vue&type=template&id=30273730&scoped=true&"
import script from "./HowItWorksMobileView.vue?vue&type=script&lang=js&"
export * from "./HowItWorksMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30273730",
  null
  
)

export default component.exports